enum VodEndpoints {
    GET = '/assets/vods',
    GET_BY_ID = '/assets/vods/{id}',
    CREATE = '/assets/vods/{id}/clips',
    OVERWRITE = '/assets/vods/{id}',
    GET_CLIPS_BY_ID = '/assets/vods/{id}/clips',
}

export { VodEndpoints };
